import { useSyncExternalStore } from 'react';






export type FormStore<T extends object> = {
  get: () => T;
  set: (patch: Partial<T>) => void;

  useValue: () => T;
};

export function createFormStore<T extends object>(initial: T): FormStore<T> {
  let state = initial;
  const listeners = new Set<() => void>();
  const subscribe = (fn: () => void): (() => void) => {
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  };
  const get = (): T => state;
  return {
    get,
    set: (patch) => {
      state = { ...state, ...patch };
      for (const l of listeners) l();
    },
    useValue: () => useSyncExternalStore(subscribe, get, get),
  };
}
